import * as React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

// Global Types
import { AppState } from 'services/types';

// Global Actions
// @ts-ignore
import { resetSelectedTableCells } from 'services/selectedTableCells/actions';

// Global Selectors
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';

interface ConnectedProps {
    search?: string;
}

interface DispatchProps {
    resetSelectedTableCells: Function;
}

type Props = ConnectedProps & DispatchProps;

export class ResetSelectedTableCellsOnSearchUpdateComponent extends React.PureComponent<
    Props
> {
    componentDidUpdate(prevProps: Props): void {
        const { props } = this;

        if (props.search !== prevProps.search) {
            props.resetSelectedTableCells();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.resetSelectedTableCells();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    search: makeSelectQueryStringValue('search')
});

export default connect(
    mapStateToProps,
    {
        resetSelectedTableCells
    }
)(ResetSelectedTableCellsOnSearchUpdateComponent);
